module.exports = __webpack_public_path__ + "static/work-6859c787e5af42590ac664fe69524544.jpg";